export var INITIAL_STATE = {
  initialValuesResolved: false
};
export var INITIAL_VALUES_RESOLVED_STATE = {
  initialValuesResolved: true
};